export default "__VITE_ASSET__SYV2e5Gs__"